import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import useDocumentMeta from "../../hooks/useDocumentMeta";
import "./PostPage.css";

const PostPage = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(undefined); // undefined = ładowanie, null = nie znaleziono
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch("https://ekselowe.pl/api/getposts.php", {
      headers: { "Content-Type": "application/json; charset=UTF-8" },
    })
      .then((res) => res.json())
      .then((json) => {
        if (cancelled) return;
        const keys = Object.keys(json);
        const key = keys.includes(postId) ? postId : undefined;
        if (key === undefined) {
          setNotFound(true);
        } else {
          setPost(json[key]);
        }
      })
      .catch(() => {
        if (!cancelled) setNotFound(true);
      });
    return () => {
      cancelled = true;
    };
  }, [postId]);

  const description = post && post.text ? post.text.slice(0, 155) : undefined;

  useDocumentMeta({
    title: post ? post.title : "Aktualności",
    description,
    image: post && post.image,
    url: typeof window !== "undefined" ? window.location.href : undefined,
  });

  if (notFound) {
    return (
      <div className="post-page-container">
        <div className="post-page-content">
          <p className="post-page-back-link" onClick={() => navigate("/aktualnosci")}>&larr; Wróć do Aktualności</p>
          <h1>Nie znaleziono wpisu</h1>
          <p>Ten wpis mógł zostać usunięty lub link jest nieprawidłowy.</p>
          <Link to="/aktualnosci" className="post-page-cta">Zobacz wszystkie wpisy</Link>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="post-page-container">
        <div className="post-page-content">
          <p>Wczytywanie…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="post-page-container">
      <div className="post-page-content">
        <p className="post-page-back-link" onClick={() => navigate("/aktualnosci")}>&larr; Wróć do Aktualności</p>
        {post.image && (
          <img src={post.image} alt={post.title} className="post-page-image" />
        )}
        <h1 className="post-page-title">{post.title}</h1>
        <div className="post-page-text">
          {post.text.split("\n").map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostPage;
